export default __webpack_public_path__ + "static/media/job_offer15_m.5f7b21fe.jpg";